// api
import { imageAPI } from '@fluke/baseline-client-apis';

// utilities
import {
  getCanvasBlob,
  dataURItoBlob,
  getObjectAsJSONFile,
  getStatusIndex,
} from '@fluke/irviewer/utilities';

export default function handleSaveImages(groupImageData = {}, currentOrganization = '') {
  for (const [imageId, imageData] of Object.entries(groupImageData)) {
    const { DATA = {}, sort_info = {} } = imageData || {};
    const { img = {}, json = {} } = DATA;
    const { origin_path = '' } = sort_info;

    const { IRVIEWER = {} } = json;
    const { status = {} } = IRVIEWER;
    const { code = 0 } = status;

    // save the next image info
    if (Object.entries(json).length > 0) {
      imageAPI
        .storeUpdatedThermalImage(
          imageId,
          {
            origin_path,
            reason_code: code,
            status: getStatusIndex(code),
            preview: getCanvasBlob(dataURItoBlob(img.src)),
            info: getObjectAsJSONFile(json),
          },
          currentOrganization,
        )
        .catch((error) =>
          console.error(`Failed to update thermal image for ID ${imageId}:`, error),
        );
    }
  }
}
